// src/components/common/bulk/ResultsSummary.jsx
import React from 'react';
import { CheckCircle, XCircle, Eye, Plus } from 'lucide-react';
import styles from './ResultsSummary.module.css';

const ResultsSummary = ({
  results,
  onCreateMore,
  onViewResults,
  title = 'Submission Complete!',
  successLabel = 'Successfully Created',
  failedLabel = 'Failed',
  totalLabel = 'Total Submitted',
  viewResultsLabel = 'View Created Orders',
  createMoreLabel = 'Create More Orders',
  failedListTitle = 'Failed Orders:',
}) => {
  const { summary } = results;

  return (
    <div className={styles.resultsSummary}>
      <div className={styles.header}>
        <h2>{title}</h2>
      </div>

      <div className={styles.summaryCards}>
        <div className={`${styles.card} ${styles.success}`}>
          <CheckCircle size={48} />
          <div className={styles.cardValue}>{summary.successCount}</div>
          <div className={styles.cardLabel}>{successLabel}</div>
        </div>

        {summary.failureCount > 0 && (
          <div className={`${styles.card} ${styles.error}`}>
            <XCircle size={48} />
            <div className={styles.cardValue}>{summary.failureCount}</div>
            <div className={styles.cardLabel}>{failedLabel}</div>
          </div>
        )}

        <div className={styles.card}>
          <div className={styles.cardValue}>{summary.totalSubmitted}</div>
          <div className={styles.cardLabel}>{totalLabel}</div>
        </div>
      </div>

      <div className={styles.actions}>
        {onViewResults && (
          <button onClick={onViewResults} className={styles.viewButton}>
            <Eye size={18} />
            {viewResultsLabel}
          </button>
        )}
        {onCreateMore && (
          <button onClick={onCreateMore} className={styles.createButton}>
            <Plus size={18} />
            {createMoreLabel}
          </button>
        )}
      </div>

      {summary.failureCount > 0 && (
        <div className={styles.failedOrders}>
          <h4>{failedListTitle}</h4>
          <ul>
            {results.results
              .filter(r => r.status === 'failed')
              .map(r => (
                <li key={r.rowNumber}>
                  Row {r.rowNumber}: {r.errors.join(', ')}
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ResultsSummary;
